import { Card as MuiCard } from '@mui/material';
import { BORDER_RADIUS, HOVER_TRANSFORM, TRANSITION_DURATION } from '../../../constants/styles';

export const Card = ({ children, height, onClick, href, bgColor = 'transparent', sx = {} }) => {
  const commonCardStyle = {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    transform: 'scale(1)',
    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    height: height || 'auto',
    backgroundColor: bgColor,
    cursor: (onClick || href) ? 'pointer' : 'default',
    textDecoration: 'none',
    '&:hover': {
      transform: HOVER_TRANSFORM + ' !important',
      boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
    },
    '&:active': {
      transform: 'scale(0.98)',
      transition: 'transform 0.1s ease-in-out',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(255,255,255,0.1)',
      opacity: 0,
      transition: `opacity ${TRANSITION_DURATION} cubic-bezier(0.4, 0, 0.2, 1)`,
      pointerEvents: 'none'
    },
    '&:active::after': {
      opacity: 1,
      transition: 'opacity 0.1s ease-in-out'
    },
  };

  // Merge sx prop while preserving hover styles and base transform
  const mergedSx = {
    ...commonCardStyle,
    ...sx,
    transform: sx.transform || 'scale(1)',
    '&:hover': {
      ...(sx['&:hover'] || {}),
      transform: HOVER_TRANSFORM + ' !important',
      boxShadow: '0 8px 24px rgba(0,0,0,0.15) !important',
    },
    '&:active': {
      ...(sx['&:active'] || {}),
      transform: 'scale(0.98) !important',
      transition: 'transform 0.1s ease-in-out',
    },
    transition: sx.transition || commonCardStyle.transition,
  };

  const cardProps = {
    sx: mergedSx
  };

  if (href) {
    cardProps.component = 'a';
    cardProps.href = href;
    cardProps.target = '_blank';
    cardProps.rel = 'noopener noreferrer';
  }

  if (onClick) {
    cardProps.onClick = onClick;
  }

  return <MuiCard {...cardProps}>{children}</MuiCard>;
}; 